import OrderVerificationContainer from "../../../Component/Application/OrderVerification/OrderVerificationContainer";

const OrderVerificationPage = () => {
    return (
        <div className="page-body">
            <OrderVerificationContainer />
        </div>
    );
};

export default OrderVerificationPage;